<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>{{this.pageTitle}} </strong>           
          </div>  
          <div class="box">
              <div id="overlay" >
             <div class="loader"></div>
           </div>
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-card-body>
                <b-row> 
                 <b-col md="6">
                    <b-form-group label="Delivery Agent"  label-size="sm"
                      :label-cols="5" >                   
                      <v-select v-model="selected" :options="this.data1" @input="handler" name="selected" v-validate="'required'" :class="{ danger: errors.has('selected') }">
                      </v-select>
                      <span v-show="errors.has('selected')" class="danger">
                          {{ errors.first('selected') }}
                      </span>    
                    </b-form-group>                
                    <b-form-group label="Deposit Amount"  label-size="sm"
                      :label-cols="5" > 
                        <input class="input" type="text" name="DepositAmt"  v-model="shipmentprice" v-validate="'required'" :class="{'form-control input': true, 'is-danger': errors.has('form-1.DepositAmt') }" placeholder="Enter Deposit Amount" @keypress="onlyNumber"
                        >
                        <span v-show="errors.has('form-1.DepositAmt')" class="help is-danger" style="color:red">{{ errors.first('form-1.DepositAmt') }}</span>
                    </b-form-group>  
                    <b-form-group label="Payment Mode"  label-size="sm"
                      :label-cols="5" > 
                       
                        <input type="radio" name="paymentmode"  id="myCheck"  v-on:change="payment" v-model="paymentmode" v-bind:value="0" checked> <span>  BankTransfer</span>&nbsp;&nbsp;&nbsp;  
                              <!--  <input type="radio" name="paymentmode"  id="myCheck"  v-on:change="payment" v-model="customer.paymentmode" v-bind:value="0" checked> <span>  BankTransfer</span>&nbsp;&nbsp;&nbsp; -->  
                             <input type="radio" name="paymentmode"  v-on:change="payment"  id="myCheck"  v-model="paymentmode" v-bind:value="1"> <span>  Cash</span >
                            
                    </b-form-group>  


                  
                    <b-form-group label="Receipt No" id="rno"  style="display:block;" label-size="sm"
                      :label-cols="5" > 
                        <input class="input" type="text" id= "receiptno" name="Receiptno"  v-model="customer.Receiptno"  :class="{'form-control input ': true, 'is-danger': errors.has('form-1.Receiptno') }" placeholder="Enter Receipt No"  @keypress="nospace">
                       <span v-show="errors.has('form-1.Receiptno')" class="help is-danger">{{ errors.first('form-1.Receiptno') }}</span>
                    </b-form-group> 

                    <b-form-group label="OTP"  label-size="sm"
                      :label-cols="5" > 
                        <input class="input" type="text" name="otp"  v-model="customer.otp" v-validate="'required'" :class="{'form-control input ': true, 'is-danger': errors.has('form-1.otp') }" placeholder="Enter OTP" @keypress="onlyNumber" >
                       <span v-show="errors.has('form-1.otp')" class="help is-danger" style="color:red">{{ errors.first('form-1.otp') }}</span>
                    </b-form-group>

                    <b-form-group label="Remark"  label-size="sm"
                      :label-cols="5" > 
                        <input class="input" type="text" name="remark"  v-model="customer.remark"  :class="{'form-control input ': true, 'is-danger': errors.has('form-1.remark') }" placeholder="Enter Remark" >
                     


                    </b-form-group>


                    
                     <footer class="text-right mr-2" >
                        <b-button type="submit" class="mr-4" size="md" variant="primary">Submit</b-button>
                        <b-button type="button" size="md" variant="danger" @click="clear">Clear</b-button>
                    </footer>
                 </b-col>
                 <b-col md="6">
                 </b-col>
               </b-row>
             </b-card-body>
            </form>          
            <b-row>
              <b-col md="12">
                <b-card-body>
                  <div id="CodshipmnetAmountReport" style = "display : none">
                    <!-- <p><code class="highlighter-rouge">Select Shipment</code> to collected amount.</p> -->
                    <table class="table table-striped table-bordered border=1" >
                      <thead v-if="shipmentdata.length > 0" >
                        <tr>
                          <th>Sr.No.</th>
                          <th>Delivery Agent</th>
                          <th>Shipping ID</th>
                          <th>COD</th>
                          <th>Order Date</th>
                          <th>Delivery Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr  v-for="(value, firstIndex) in shipmentdata">
                           <td>{{firstIndex+1}}</td> 
                          <td>{{ value.daname }}</td>
                          <td>{{ value.shippingid }}</td>
                          <td>{{ value.pendingcodcollectable }}</td>
                          <td>{{ value.order_date }}</td>
                          <td>{{ value.delivery_date }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div id="CodAmountReport" style = "display : none">
                    <table class="table table-responsive-sm table-bordered table-striped table-sm  border=1">
                          <tr style="color:#fff;background-color:#17a2b8;">
                              <th>Assign</th>
                              <th>Prepaid </th>
                              <th>Cash </th>
                              <th>Delivered </th>
                              <th>OFD </th>
                              <th>NDR </th>
                          </tr>
                          <tr style="color:Gray;background-color:#F7F6F3;">
                              <td> {{ this.assignCount }} </td>
                              <td> {{ this.prepaid }} </td>
                              <td> {{ this.cash }} </td>
                              <td> {{ this.deliveredShimpments }} </td>
                              <td> {{ this.ofd }} </td>
                              <td> {{ this.ndr }} </td>
                          </tr>
                    </table>
                  </div>
                  <div id="CodAmountTable" style = "display : none">
                    <table class="table table-responsive-sm table-bordered table-striped table-sm border=1">
                        <tr>
                            <td style="width: 51%;">Todays Cash Amount  </td>
                            <td style="width: 25%;"> {{ this.TodaysAmt }} </td>
                        </tr>
                        <tr>
                            <td>Pending Cash Amount </td>
                            <td> {{ this.PendingAmt }} </td>
                        </tr>
                        <tr>
                            <td>Total Amount </td>
                            <td> {{ this.TotalAmt }} </td>
                        </tr>
                         <tr>
                            <td>WalletAmount Available </td>
                            <td> {{walletamount}} </td>
                        </tr>
                    </table>
                  </div>
                  <table class="table table-responsive-sm table-bordered table-striped table-sm " border="1" >
                    <thead v-if="codclosureDetails.length > 0" >
                      <tr>
                        <th>Credit Amount</th>
                        <th>Debit Amount</th>
                        <th>Created Date</th>
                        <th>Delivery Date</th>
                        <!-- <th>Reason</th> -->
                        <!-- <th>Created By</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="value in codclosureDetails" >
                        <td>{{ value.depositeamount }}</td>
                        <td>{{ value.pendingamount }}</td>
                        <td>{{ value.createddate | datechange}} </td>
                        <td>{{ value.codclosuredate | datechange}}</td>
                        <!-- <td>{{ value.dayclosureby }}</td> -->
                      </tr>
                    </tbody>
                  </table>
                </b-card-body>
             </b-col>
            </b-row>            
          </div>
        </b-card>
      </b-col>       
    </b-row>
  </div>
</template>
<style>
.notification.is-success {
      background-color: green!important;
      width: 400px;
}
</style>
<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
export default {
  data: function() {
    return {
      pageTitle: 'COD Day Closure',
      data1: [],
      codclosureDetails : [],
      shipmentdata:[],
      //deliveryagentmasteridobj: {},
      clientdata: [],
      customerSearch: {},
      TodaysAmt : 0,
      PendingAmt : 0,
      TotalAmt : 0,
      assignCount : 0,
      prepaid : 0,
      cash : 0,
      ofd : 0,
      ndr : 0,
      walletamount:0,
      shipmentprice:'',
      Receiptno:0,
      remark:'',
      paymentmode:0,
      deliveredShimpments : 0,
      deliveryagentmasterid: '',
      customer: {},      
      selected: {id: '0', label: 'Select Delivery Agent'}
    }
  },
  created: function() {
    this.validateUser()
    this.displaydata()
    //this.getAllCodClosureDetails('166')
  },
  methods: {
    // check: function(e,val) {      
    //       if(e.target.checked){
    //         this.shipmentprice = (parseFloat(this.shipmentprice) +parseFloat(val)).toFixed(2); 
    //       }else{
    //         this.shipmentprice = (parseFloat(this.shipmentprice)-parseFloat(val)).toFixed(2);   
    //       }          
    //     document.getElementById("DepositAmtId").value =this.shipmentprice;
    //     console.log(this.shipmentprice);    
    // },
    handler:function(paymentParams,dagentid) {
        //console.log('idd',this.selected.key);
        this.getPaymentDetails(this.selected.key);
        this.codCalculation(this.selected.key);
    },

    payment:function() {

  var checkBox = document.getElementById("myCheck");

  //var text = document.getElementById("text");
 if (checkBox.checked == true){
  
    rno.style.display = "block";
    receiptno.display="block";
   
  } else {
    
    rno.style.display = "none";
    receiptno.display="none";
   
  }
        
    },
    validateForm(scope) {  
    //  console.log(this.shipmentprice);
    // console.log(this.customer.remark) ;
    // console.log(this.customer.Receiptno);  
      //console.log('tes:',this.deliveryagentmasteridobj.deliveryagentmasterid);
      this.$validator.validateAll(scope).then(result => {        
        if (result) {
                var y = this.shipmentprice; 
 
                var shippingIds=[];
                if(y.length>0){
                  for (var i = 0; i < y.length; i++) {
                      
                        shippingIds.push(y[i].value);
                      
                  }
                }
                if(shippingIds.length==0){
                  alert("Please select shipping");
                //    this.$fire({
                //   text:"Please select shipping.",
                //   type: "warning",
                //   timer: 30000
                // });
                  //Utils.notify("Please select shipping", "error");
                  return false;
                }
                if(( this.customer.Receiptno=="" || this.customer.Receiptno==undefined || this.customer.Receiptno==null) && this.paymentmode=='0') 
                 {
                  
                  alert("Please insert Receiptno");
                //    this.$fire({
                //   text:"Please insert Receiptno.",
                //   type: "warning",
                //   timer: 30000
                // });
                
                  return false;
                
            }
            // if(this.paymentmode=='0'){
            //  if(parseInt(this.shipmentprice) > parseInt(this.TotalAmt)) 
            //     {

            //      Utils.notify("Invalid!! Deposite Amount should not be greater then Total Amount", "error");
            //     //  this.$fire({
            //     //   text:"Invalid!! Deposite Amount should not be greater then Total Amount",
            //     //   type: "warning",
            //     //   timer: 30000
            //     // });

            //       return false;

            //     }
            //   }
             //           if(this.paymentmode=='0'){
             // if(parseInt(this.shipmentprice) > parseInt(this.TotalAmt)) 
             //    {

             //     Utils.notify("Invalid!! Deposite Amount should not be greater then Total Amount", "error");
             //    //  this.$fire({
             //    //   text:"Invalid!! Deposite Amount should not be greater then Total Amount",
             //    //   type: "warning",
             //    //   timer: 30000
             //    // });

             //      return false;

             //    }
             //  }

          //console.log(shippingIds);
             if( this.selected.key == null && this.selected.key == undefined){
                  // Utils.notify("Please select SR name", "error");
                //   this.$fire({
                //   text:"Please select SR name",
                //   type: "warning",
                //   timer: 30000
                // });
              }else{
                //this.shipmentprice
               // console.log(parseFloat(this.TotalAmt) );
                //console.log(parseFloat(this.customer.DepositAmt));
                 // if(parseFloat(this.TotalAmt) === parseFloat(this.customer.DepositAmt)){
                if(parseFloat(this.shipmentprice)>0){
                  document.getElementById("overlay").style.display = "block";
                      var userdata = localStorage.getItem('userData');
                      var userInfo = JSON.parse(userdata);
                      //console.log('tes:',this.deliveryagentmasteridobj);
                // this.TodaysAmt = parseFloat(resultSetData['codcollectable']).toFixed(2);
                // //this.customer.DepositAmt = 0;
                // this.PendingAmt = parseFloat(resultSetData['pendingcodcollectable']).toFixed(2);
                //  this.TotalAmt = (parseFloat(resultSetData['codcollectable']) +parseFloat(resultSetData['pendingcodcollectable'])).toFixed(2);
                //  console.log("Total",this.TotalAmt);
                      // var xbhubid = this.$route.query.xbhubid;
                      // var codclosedby = this.$route.query.codclosedby;
                      var xbhubid = `${userInfo.pickuplocationmasterid}`;
                      var codclosedby = `${userInfo.sysemailid}`;
                      const codPayload = {
                          deliveryagentmasterid : this.selected.key,
                          // totalamount: this.TotalAmt ,
                          wallet_amount:this.walletamount,
                          shippingids:shippingIds,
                          pendingamount  : this.PendingAmt,
                          // pendingamount  : 0,
                          codclosedby  : codclosedby,
                          xbhubid  : xbhubid,
                          otp: this.customer.otp,
                          receiptno:this.customer.Receiptno,
                         // depositamount:this.shipmentprice,
                          depositamount:this.shipmentprice,
                         // paymentmode:this.customer.bankpaymentmode,
                          paymentmode:this.paymentmode,
                          remark:this.customer.remark,
                            // hub_id:`${userInfo.pickuplocationmasterid}`,
      
                      }
                      console.log("codPayload",codPayload);
                      // return false;
                    //Invalid!! OTP not found or Expired. Kindly generate new OTP
                    // console.log("codPayload : ", codPayload);
                   //  return false;
                      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/marksrcodclosure`,codPayload ).then(result => {
                          // console.log('Retunvalue',result.body.returnvalue);
                          if (result.body.returnmsg === "Successful") {
                            document.getElementById("overlay").style.display = "none";
                              Utils.notify("Added successfully!", "success");
                               // this.$fire({
                               //    text:result.body.returnvalue,
                               //    type: "success",
                               //    timer: 30000
                               //  });
                              this.customer.otp='';
                              this.customer.Receiptno='';
                              
                              this.shipmentprice= '';
                              this.customer.remark='';
                            this.getPaymentDetails(this.selected.key);
                            this.codCalculation(this.selected.key);
                               // this.getPaymentDetails();
                              // this.$router.push('/codSRDayClosure');
                              // document.getElementById('CodAmountTable').style.display = 'none';
                              // document.getElementById('CodshipmnetAmountReport').style.display = 'none';   
                            }else{
                              Utils.notify("Invalid!! OTP not found or Expired. Kindly generate new OTP", "error");
                              // this.$fire({
                              //     text:"Invalid!! OTP not found or Expired. Kindly generate new OTP",
                              //     type: "error",
                              //     timer: 30000
                              //   });
                                document.getElementById("overlay").style.display = "none";
                            }
                      })
                      .catch(ex => {
                        console.log("error", ex);
                      });
                }else{
                  // console.log('Could not deposite amount as it is not equal to Total amount');
                    Utils.notify("Could not deposite amount as it is not equal to Total amount", "error");
                     // this.$fire({
                     //              text:"Could not deposite amount as it is not equal to Total amount",
                     //              type: "error",
                     //              timer: 30000
                     //            });
                }
            }
        } else {
          Utils.notify("Please fill mandatory fields", "error");
            // this.$fire({
            //              text:"Please fill mandatory fields",
            //              type: "warning",
            //              timer: 30000
            //           });
        }
      })
    },
    codCalculation : function(deliveryagentmasterid){
        //console.log('codCalculation',deliveryagentmasterid);
        if (deliveryagentmasterid != '') {
              var depositAmt = 0;
              if(this.customer.DepositAmt != ''){
                 depositAmt = this.customer.DepositAmt;
              }
              let TodaysTotalAmt = this.TodaysAmt;
              //if(parseFloat(TodaysTotalAmt) < parseFloat(depositAmt)){
              if(parseFloat(this.TotalAmt) < parseFloat(depositAmt)){
                  Utils.notify("Check deposite amount as it is more than Total amount", "error");
                  // this.$fire({
                  //        text:"Check deposit amount as it is more than Total amount",
                  //        type: "warning",
                  //        timer: 30000
                  //     });
              }else{

              }
        }
    },
    getPaymentDetails: function(deliveryagentmasterid) {
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
        if (deliveryagentmasterid != '' && deliveryagentmasterid != undefined && deliveryagentmasterid != null) {
          
               // var y = document.getElementsByClassName('shipmentscheckbox'); 
               //      var shippingIds=[];
               //      if(y.length>0){
               //        for (var i = 0; i < y.length; i++) {
               //            if (y[i].checked == true){
               //              shippingIds.push(y[i].value);
               //            }
               //        }
               //      }
            // this.shippingIds=[];
            // var items = document.getElementsByClassName('shipmentscheckbox');
            // for (var i = 0; i < items.length; i++) {         
            //     if (items[i].checked == true){
            //         items[i].checked = false;
            //       }
            // }
          //checkboxsubmit 
            const getsrCodPayload = {
              deliveryagentmasterid : deliveryagentmasterid, 
                hub_id:`${userInfo.pickuplocationmasterid}`,
                 is_finance_superadmin:`${userInfo.is_finance_superadmin}`,  
            }
            this.$http.post(`${CONSTANTS.API_URL}/getsrcodclosurelist`,getsrCodPayload).then(result => {

            if (result.body.returnmsg=== 'Successful') {            
               document.getElementById('CodshipmnetAmountReport').style.display = 'block';
              this.shipmentdata = result.body.returnvalue;
              // console.log("shipment", this.shipmentdata );
            }else{
               document.getElementById('CodshipmnetAmountReport').style.display = 'none';
               alert('Result not found');  
               // this.$fire({
               //    text:"Result not found",
               //    type: "error",
               //    timer: 30000
               //  });          
            }
            }).catch(ex => {
             console.log("error", ex);
            });           
            let today = new Date();
            var currentdate = this.formatDate(today);
            const getCodPayload = {
                deliveryagentmasterid : deliveryagentmasterid,
                fromdate :currentdate,
                hub_id:`${userInfo.pickuplocationmasterid}`,
                is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
      
            }
            // console.log('getCodPayload : ', getCodPayload);
            this.$http.post(`${CONSTANTS.API_URL}/getsrcodclosuredetails`,getCodPayload).then(result => {
                document.getElementById('CodAmountTable').style.display = 'block';
                document.getElementById('CodAmountReport').style.display = 'none';
                var resultSetData = result.body.returnvalue[0];
                // this.walletamount=result.body.returnvalue[0].wallet_amount;
                // console.log("kkkkkkk",this.walletamount);
                //console.log('result:',result.body);
                //console.log('resultSetData',resultSetData);
                let assignCountval = parseInt(resultSetData['totalprepaid']) + parseInt(resultSetData['totalcod']);
                //console.log('result', resultSetData['codcollectable']);
                this.assignCount = assignCountval;
                this.prepaid = resultSetData['totalprepaid'];
                this.cash = resultSetData['totalcod'];
                this.walletamount=parseFloat(resultSetData['wallet_amount']).toFixed(2);
                this.deliveredShimpments = resultSetData['totaldelivered'];
                this.ofd = resultSetData['totalofd'];
                this.ndr = resultSetData['totalndr'];
                this.TodaysAmt = parseFloat(resultSetData['codcollectable']).toFixed(2);
                //this.customer.DepositAmt = 0;
                this.PendingAmt = parseFloat(resultSetData['pendingcodcollectable']).toFixed(2);
                 this.TotalAmt = (parseFloat(resultSetData['codcollectable']) +parseFloat(resultSetData['pendingcodcollectable'])).toFixed(2);
              //  this.TotalAmt = resultSetData['pendingcodcollectable'];
                //this.TotalAmt = 0;
            })
            .catch(ex => {
              console.log("error", ex);
            });

        } else {
            //console.log('in else ');
            document.getElementById('CodAmountTable').style.display = 'none';
             document.getElementById('CodshipmnetAmountReport').style.display = 'none';
            document.getElementById('CodAmountReport').style.display = 'none';
            this.customer = {};
        }
    },
    displaydata: function() {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        const deliveryagentobj = {
          deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
          isactive: '1',
            hub_id:`${userInfo.pickuplocationmasterid}`,
             is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
      
        }
    this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, 
      deliveryagentobj).then(result => {
            this.data1 = result.body;
            // console.log('data',this.data1);
            var data = [];
              result.body.forEach(function (srData) {
                data.push({
                  key:srData.deliveryagentmasterid,
                  label:srData.deliveryagentfirstname+ '  '+srData.deliveryagentlastname+ ' - '+srData.deliveryagentmasterid
                });
              });
              this.data1 = data;
        }).catch(ex => {
            console.log('error-----', ex)
        });
    },
    getAllCodClosureDetails : function(deliveryagentid){
         var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
        const getcodcloserdetailsPayoad = {
          deliveryagentmasterid: `${deliveryagentid}`,
             hub_id:`${userInfo.pickuplocationmasterid}`,
      
        }
        this.$http.post(`${CONSTANTS.API_URL}/getallcodclosuredetails`, getcodcloserdetailsPayoad).then(result => {
            //console.log('result.body',result.body.returnvalue);
            this.codclosureDetails = result.body.returnvalue;
        }).catch(ex => {
            console.log('error-----', ex)
        });
    },
    validateUser : function(){
      let ValidateToken = "sKB3uGF0qvklWhTLOgsIXDRJc";
      if (this.$route.query.token === undefined || this.$route.query.token !== ValidateToken) {
        //  console.log('session logged done',this.$route.query.token);
        //  console.log(typeof(this.$route.query.xbhubid));
    //      localStorage.setItem('userData', '')
      //    localStorage.setItem('activeTime', '')
        //  localStorage.setItem('Coduser', '')
        //  this.$router.push('codSRDayClosure')
      }
    },
    onlyNumber : function($event){
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
       if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 8) {
          $event.preventDefault();
       }
    },

    nospace : function($event){

      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      
       if (keyCode ==32) {
          $event.preventDefault();
       }
    },
    clear: function() {
        this.customer = {}
        this.shipmentprice=''; 
        this.errors.clear('form-1')
        document.getElementById('CodAmountTable').style.display = 'none';
        document.getElementById('CodshipmnetAmountReport').style.display = 'none';
        document.getElementById('CodAmountReport').style.display = 'none';
        this.selected = {id: '0', label: 'Select SR'};
    },
    formatDate: function(date) {
        var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [year, month, day].join("-");
    },
  },
    filters: {
      capitalize: function(value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
    },
    datechange: function(value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        // var hours = d.getHours();
        // var minutes = d.getMinutes();
        // var ampm = hours >= 12 ? 'pm' : 'am';
        // hours = hours % 12;
        // hours = hours ? hours : 12; // the hour '0' should be '12'
        // minutes = minutes < 10 ? '0'+minutes : minutes;
        // var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year;

      }
    }
  }
};
</script>

